import React from 'react';
import { CREATE_INTENT } from './common/constants/intents';
import { LiftMeasurementForm } from './lift-measurement-form';

export const LiftMeasurementCreate = props => <LiftMeasurementForm {...props} intent={CREATE_INTENT} />;
